import { defineMessages } from '@jutro/locale';

export default defineMessages({
    savingPolicyChange: {
        id: 'ml.endorsement.pup.directives.templates.pup-your-policies.savingPolicyChange',
        defaultMessage: 'Saving policy change'
    },
    makeChanges: {
        id: 'ml.endorsement.pup.directives.templates.pup-your-policies.makeChanges',
        defaultMessage: 'Make Changes'
    },
});
